import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=bd572f88&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=ts"
export * from "./ProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=bd572f88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd572f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd572f88')) {
      api.createRecord('bd572f88', component.options)
    } else {
      api.reload('bd572f88', component.options)
    }
    module.hot.accept("./ProjectModal.vue?vue&type=template&id=bd572f88&scoped=true", function () {
      api.rerender('bd572f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectModal.vue"
export default component.exports